import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from 'tss-react/mui';
import {FormattedMessage} from 'react-intl';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import {SCREENS} from '../constants/documentCollection';
import {useDocumentCollection} from '../context/DocumentCollectionContext';

const useStyles = makeStyles()((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '60vh',
    padding: '40px 20px',
    textAlign: 'center',
  },
  icon: {
    fontSize: theme.typography.pxToRem(64),
    color: theme.palette.error.main,
    marginBottom: 20,
  },
  title: {
    fontSize: theme.typography.pxToRem(24),
    fontWeight: 700,
    fontFamily: 'Ploni, Arial, sans-serif',
    color: theme.palette.text.primary,
    marginBottom: 12,
  },
  subtitle: {
    fontSize: theme.typography.pxToRem(16),
    fontFamily: 'Ploni, Arial, sans-serif',
    color: theme.palette.text.secondary,
    marginBottom: 32,
    lineHeight: 1.6,
  },
  whatsappButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    backgroundColor: '#25D366',
    color: '#fff',
    border: 'none',
    borderRadius: 25,
    padding: '14px 32px',
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 600,
    fontFamily: 'Ploni, Arial, sans-serif',
    cursor: 'pointer',
    textDecoration: 'none',
    transition: 'background-color 0.2s',
    '&:hover': {
      backgroundColor: '#1da851',
    },
  },
}));

const InvalidLinkScreen = ({variant}) => {
  const {classes} = useStyles();
  const {currentScreen, contact} = useDocumentCollection();
  const whatsAppNumber = contact.whatsAppNumber;
  const whatsappLink = `https://wa.me/${whatsAppNumber}`;

  const isExpired = variant === 'expired' || currentScreen === SCREENS.EXPIRED;
  const prefix = isExpired ? 'docCollection.expired' : 'docCollection.invalid';

  return (
    <div className={classes.container}>
      <ErrorOutlineIcon className={classes.icon} />
      <div className={classes.title}>
        <FormattedMessage id={`${prefix}.title`} />
      </div>
      <div className={classes.subtitle}>
        <FormattedMessage id={`${prefix}.subtitle`} />
      </div>
      {whatsAppNumber && (
        <a
          href={whatsappLink}
          target='_blank'
          rel='noopener noreferrer'
          className={classes.whatsappButton}
        >
          <FormattedMessage id={`${prefix}.whatsapp`} />
        </a>
      )}
    </div>
  );
};

InvalidLinkScreen.propTypes = {
  variant: PropTypes.oneOf(['expired', 'invalid']),
};

InvalidLinkScreen.defaultProps = {
  variant: undefined,
};

export default InvalidLinkScreen;
